import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./SortOrder.scss";

const SortOrder = ({
	index,            // current zero-based position
	total,            // total count
	onMove,           // (toIndex: number) => void
	onMoveTop,        // () => void (optional)
	onMoveBottom,     // () => void (optional)
}) => {
	const atTop = index === 0;
	const atBottom = index === total - 1;

	const handleTop = () => {
		if (atTop) {
			return;
		}
		if (onMoveTop) {
			onMoveTop();
		}
		else {
			onMove?.(0);
		}
	};

	const handleUp = () => {
		if (atTop) {
			return;
		}
		onMove?.(index - 1);
	};

	const handleDown = () => {
		if (atBottom) {
			return;
		}
		onMove?.(index + 1);
	};

	const handleBottom = () => {
		if (atBottom) {
			return;
		}
		if (onMoveBottom) {
			onMoveBottom();
		}
		else {
			onMove?.(total - 1);
		}
	};

	const getClass = (disabled) =>
		`sort-order-controls-btn ${disabled ? "sort-disabled" : ""}`;

	return (
		<div className="sort-order">
			<div className="sort-order-position">
				<h4>Order</h4>
				<p>{index + 1}</p>
			</div>

			<div className="sort-order-controls">
				{/* Send to Top */}
				<div
					className={getClass(atTop)}
					onClick={!atTop ? handleTop : undefined}
				>
					<FontAwesomeIcon icon={faChevronUp} className="top-icon" />
					<FontAwesomeIcon icon={faChevronUp} className="bottom-icon" />
				</div>

				{/* Up One */}
				<div
					className={getClass(atTop)}
					onClick={!atTop ? handleUp : undefined}
				>
					<FontAwesomeIcon icon={faChevronUp} className="single-icon" />
				</div>

				{/* Down One */}
				<div
					className={getClass(atBottom)}
					onClick={!atBottom ? handleDown : undefined}
				>
					<FontAwesomeIcon icon={faChevronDown} className="single-icon" />
				</div>

				{/* Send to Bottom */}
				<div
					className={getClass(atBottom)}
					onClick={!atBottom ? handleBottom : undefined}
				>
					<FontAwesomeIcon icon={faChevronDown} className="top-icon" />
					<FontAwesomeIcon icon={faChevronDown} className="bottom-icon" />
				</div>
			</div>
		</div>
	);
};

export default SortOrder;
